import generateDeviceId from 'Helper/generateDeviceId';
import Cookies from 'universal-cookie';

const patchChangeDevicePayload = ({ monitoringStatus }) => {
  const cookies = new Cookies();

  const deviceId = generateDeviceId();

  cookies.set('deviceId', deviceId);

  const payload = { newDeviceId: deviceId, operatorPresenceId: monitoringStatus?.presence?.id };

  return payload;
};

export default patchChangeDevicePayload;
